import { parseJwt } from "@connect/post-message/jwt";
import * as z from "zod/mini";
import type { IdentityChallengeTokenPayload } from "./identity-challenge-token.types";

const claims = {
  type: z.literal("identity_verification"),
  params: z.looseObject({ identityId: z.string().check(z.minLength(1)) }),
  iat: z.optional(z.number()),
  exp: z.optional(z.number()),
};

const identityChallengeTokenSchema = z.union([
  z.looseObject({ ...claims, iss: z.literal("dev-platform") }),
  z.looseObject({ ...claims, issuer: z.literal("dev-platform") }),
]);

export function decodeIdentityChallengeToken(token: string): IdentityChallengeTokenPayload | null {
  const result = z.safeParse(identityChallengeTokenSchema, parseJwt(token));
  return result.success ? result.data : null;
}
